import { PawPrint } from "lucide-react";

export const Header = () => {
  return (
    <header className="bg-card border-b border-border px-4 py-3 sm:px-6 sm:py-4">
      <div className="flex items-center gap-3">
        {/* Logo icon */}
        <span className="bg-primary rounded-lg flex items-center justify-center w-10 h-10 flex-shrink-0">
          <PawPrint className="text-primary-foreground w-5 h-5" />
        </span>
        
        {/* Text block aligned next to icon */}
        <div className="flex flex-col">
          <span className="font-bold text-primary text-xl leading-tight">
            GdzieSchronisko
          </span>
          <p className="text-sm text-muted-foreground hidden sm:block leading-tight">
            Mapa pomocy dla zwierząt
          </p>
        </div>
      </div>
    </header>
  );
};
